var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "one-btn-pop pop" }, [
    _c(
      "div",
      { staticClass: "pop-box", class: { popBoxUpgrade: _vm.popBoxUpgrade } },
      [
        _c("div", { staticClass: "pop-main" }, [
          _c("div", { staticClass: "pop-main-top" }, [
            _vm._v(_vm._s(_vm.oneBtnPopText.top))
          ]),
          _vm._v(" "),
          !_vm.popBoxUpgrade
            ? _c("div", { staticClass: "pop-main-test" }, [
                _vm._v(_vm._s(_vm.oneBtnPopText.main))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.popBoxUpgrade
            ? _c(
                "div",
                {
                  staticClass: "pop-main-test",
                  class: { en: _vm.lang === "en" }
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("device.upgradeTest")))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.$t("device.upgradeTestOne")))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.$t("device.upgradeTestTwo")))]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("device.upgradeTestThree")))
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.$t("device.upgradeTestFour")))])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "pop-main-bottom" }, [
            _c(
              "button",
              { staticClass: "btn-black", on: { click: _vm.closePop } },
              [_vm._v(_vm._s(_vm.oneBtnPopText.btn))]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44c0558b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44c0558b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Et/OneBtnPop.vue
// module id = null
// module chunks = 